import React, { useState, useEffect } from 'react';
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Breadcrumb from "../components/Breadcrumb";
import { menuConfig } from '../configs/MenuConfig';
import { useAuthStore } from "../store/authStore";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export default function PanelLayout({ user }) {
  // پیش‌فرض: در دسکتاپ باز (true) و در موبایل بسته (false)
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [currentUserType, setCurrentUserType] = useState(user);
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const logout = useAuthStore((state) => state.logout);

  // مدیریت تغییر سایز پنجره برای بستن/بازکردن خودکار سایدبار
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // بستن سایدبار در موبایل بعد از تغییر مسیر
  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsSidebarOpen(false);
    }
  }, [location]);


  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-vazir">
      <Header
        userType={currentUserType}
        setIsSidebarOpen={setIsSidebarOpen}
        onLogout={logout}
      />

      <div className="flex flex-1 relative overflow-hidden">
        {/* سایدبار */}
        <Sidebar
          userType={currentUserType}
          menuConfig={menuConfig}
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          currentPath={currentPath}
        />

        {/* محتوای اصلی */}
        <main className="flex-1 p-4 md:p-6 overflow-y-auto">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              userType={currentUserType}
              currentPath={currentPath}
              menuConfig={menuConfig}
            />

            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 md:p-6 min-h-[calc(100vh-180px)]">
              <Outlet />
            </div>
          </div>
        </main>

        {/* Overlay برای موبایل وقتی سایدبار باز است */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-30 md:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
      </div>
    </div>
  );
}
